'use strict';

bbw.service.ChatSvc = Class({

    statics: {
        UPDATE_CONTACTS_FROM_API_INTERVAL: 15000,
        PHOTO_SIZE_NAME: 'small',
        PHOTO_SIZE_NAME_SMALL: 'tiny'
    },

    UNREAD_COUNT_EVENT_NAME: 'bbw.chat.unread_count',

    _modelFactory: undefined,
    $q: undefined,
    _rpcClient: undefined,

    /**
     * @type {bbw.model.Contacts}
     */
    _contactsModel: undefined,

    /**
     * @type {bbw.service.chat.ClientFactory}
     */
    _chatClientFactory: undefined,

    /**
     * @type {bbw.service.chat.Client}
     */
    _chatClient: undefined,

    _isStarted: false,

    /**
     * @type {bbw.service.GrowlSvc}
     */
    _growl: undefined,

    $localStorage: undefined,

    conversations: null,
    _lastOpenedConversations: null,
    _conversationsMap: null,

    _chatIsActive: false,
    _isSubscribedContactsUpdate: false,
    currentConversation: undefined,

    $rootScope: undefined,

    _onMessageReceivedCb: undefined,
    _onConnectedCb: undefined,
    _onCurrentConversationChangeCb: undefined,
    _onCurrentConversationLoadedCb: undefined,

    _updateContactsTimeout: undefined,

    _privatePhotoAlbum: undefined,

    $inject: ['modelFactory', '$q', 'rpcClient', 'bbw.ChatClientFactory', 'growl', '$rootScope', '$localStorage'],

    construct: function(modelFactory, $q, rpcClient, chatClientFactory, growl, $rootScope, $localStorage) {
        this._modelFactory = modelFactory;
        this.$q = $q;
        this._rpcClient = rpcClient;
        this._chatClientFactory = chatClientFactory;
        this._growl = growl;
        this.$localStorage = $localStorage;
        this.$rootScope = $rootScope;
        this.$rootScope.$on('$destroy', this.stop.bind(this));
        window.addEventListener('beforeunload', this.stop.bind(this));
        this._lastOpenedConversations = [];
    },

    stop: function() {
        this.getChatClient().stop();
        this._isStarted = false;
    },

    onConnected: function(cb) {
        this._onConnectedCb = angular.isFunction(cb) ? cb : undefined;
        return this;
    },

    onCurrentConversationChange: function(cb) {
        this._onCurrentConversationChangeCb = angular.isFunction(cb) ? cb : undefined;
        return this;
    },

    onCurrentConversationLoaded: function(cb) {
        this._onCurrentConversationLoadedCb = angular.isFunction(cb) ? cb : undefined;
        return this;
    },

    _onConnected: function() {
        this._onConnectedCb && this._onConnectedCb();
    },

    onMessageReceived: function(cb) {
        this._onMessageReceivedCb = angular.isFunction(cb) ? cb : undefined;
        return this;
    },

    ensureIsStarted: function() {
        if (this._isStarted) {
            return this.$q.when();
        } else {
            return this.start();
        }
    },

    start: function() {
        if (bbw.isSysErr) {
            return this.$q.reject();
        }

        this.conversations = [];
        this._conversationsMap = undefined;

        if (this.getChatClient().isStopped()) {
            return this.$q.reject(null);
        }

        return this.getChatClient().start().then(function(result) {
            this._isStarted = true;
            return result;
        }.bind(this));
    },

    enterChatMode: function() {
        return this.start().then(this._restoreLastOpenedConversations.bind(this)).then(this.subscribeChatClientContactsUpdate.bind(this));
    },

    getIsPrivatePhotoAllowed: function(contact) {
        return this._rpcClient.get('chat/allows-private-photos/{contact_user_id}', {contact_user_id: contact.user_id}).execute().then(function(response) {
            return response.result;
        });
    },

    _restoreLastOpenedConversations: function() {
        var lastOpenedConversations = this.$localStorage[this._getLocalStorageLastOpenedConversationsKey()];
        this._lastOpenedConversations = angular.isArray(lastOpenedConversations) ? lastOpenedConversations.reduce(function(carry, element) {
            element = parseInt(element);
            if (!isNaN(element) && !~carry.indexOf(element)) {
                carry.push(element);
            }
            return carry;
        }, []) : [];
    },

    exitChatMode: function() {
        this._conversationsMap = undefined;
        this.conversations.splice(0);
        this._onMessageReceivedCb = undefined;
        this._onConnectedCb = undefined;
        this._onCurrentConversationChangeCb = undefined;
        this._onCurrentConversationLoadedCb = undefined;
        return this.$q.all([
            this.getChatClient().unsubscribeContactsUpdate(),
            this.getChatClient().unsubscribeAllChats()
        ]);
    },

    subscribeChatClientContactsUpdate: function() {
        return this.getChatClient().subscribeContactsUpdate().then(this._initContacts.bind(this)).then(this._setUpdateContactsTimer.bind(this));
    },

    _setUpdateContactsTimer: function() {
        if (this._updateContactsTimeout) {
            clearTimeout(this._updateContactsTimeout);
            this._updateContactsTimeout = undefined;
        }
        this._updateContactsTimeout = setTimeout(
            this._updateContactsFromTimer.bind(this),
            bbw.service.ChatSvc.UPDATE_CONTACTS_FROM_API_INTERVAL
        );
    },

    _updateContactsFromTimer: function() {
        this._contactsModel.updateContactsFromApi(true);
        this._setUpdateContactsTimer();
    },

    setCurrentConversation: function(conversation) {
        if (!conversation) {
            this.currentConversation = undefined;
            this._chatIsActive = false;
        } else if (this.conversations.indexOf(conversation) >= 0) {
            this.currentConversation = conversation;
            this._chatIsActive = true;
        } else {
            console.error('Conversation not found');
        }

        this._onCurrentConversationChanged();
    },

    activateChat: function() {
        this._chatIsActive = true;
        this._onCurrentConversationChanged();
    },

    deactivateChat: function() {
        this._chatIsActive = false;
        this._onCurrentConversationChanged();
    },

    isCurrentConversation: function(conversation) {
        return this.currentConversation && this.currentConversation === conversation;
    },

    openConversationByUserId: function(user_id) {
        var promise, contact = this.getContactByUserId(user_id);
        if (contact) {
            promise = this.$q.when(contact);
        } else {
            promise = this.createTemporaryContactByUserId(user_id);
        }
        return promise.then(function(contact) {
            this.openConversation(contact);
        }.bind(this));
    },

    getLastConversationUserId: function() {
        return this._lastOpenedConversations[this._lastOpenedConversations.length - 1];
    },

    openConversation: function(contact) {
        if (!this._conversationsMap) {
            this._conversationsMap = {};
        }

        var user_id = contact.user_id;

        var error = null;

        if (contact.user.is_deleted) {
            error = 'user_is_deleted';
        }

        if (this.getChatClient().isUserLocked()) {
            error = 'current_user_is_locked';
        }

        if (error) {
            this.getChatClient().markRead(user_id);
        }

        this._setLastOpenedConversation(user_id);

        if (this._conversationsMap && this._conversationsMap[user_id]) {
            this.setCurrentConversation(this._conversationsMap[user_id]);
            this._conversationsMap.error = error;
            return this.$q.when(this._conversationsMap[user_id]);
        }

        var conversation = this._modelFactory.create(bbw.model.Conversation)
            .setContact(contact)
            .setHistoryPhotoSize(bbw.service.ChatSvc.PHOTO_SIZE_NAME)
            .setContactPrivatePhotosLoader(this.getPrivatePhotosCollection.bind(this))
            .setUserPrivatePhotoAlbumLoader(this.getPrivatePhotoAlbum.bind(this));

        conversation.error = error;

        this._conversationsMap[user_id] = conversation;
        this.conversations.push(conversation);
        this.setCurrentConversation(conversation);

        if (conversation.error) {
            this._onConversationLoaded(conversation);
            return this.$q.when(conversation);
        }

        return this.getChatClient().subscribeChat(user_id).then(function() {
            return conversation.initialize().then(function() {
                this._onConversationLoaded(conversation);
                return conversation;
            }.bind(this))
        }.bind(this)).catch(function(error) {
            this.closeConversation(conversation);
            console.error('openConversation failed with ' + user_id, error);
            this._growl.error(error);
        }.bind(this));
    },

    _setLastOpenedConversation: function(user_id, remove) {
        user_id = parseInt(user_id);
        if (isNaN(user_id)) {
            return;
        }
        var idx = this._lastOpenedConversations.indexOf(user_id);
        if (idx >= 0) {
            this._lastOpenedConversations.splice(idx, 1);
        }
        remove || this._lastOpenedConversations.push(user_id);
        this.$localStorage[this._getLocalStorageLastOpenedConversationsKey()] = angular.copy(this._lastOpenedConversations);
    },

    getLastOpenedConversationUserId: function() {
        var len = this._lastOpenedConversations.length;
        if (!len) {
            return undefined;
        }
        return this._lastOpenedConversations[len - 1];
    },

    closeConversationByUserId: function(contact_user_id, unattended) {
        if (!this._conversationsMap || !this._conversationsMap[contact_user_id]) {
            this.setCurrentConversation();
            return this.$q.when(undefined);
        }
        if (unattended) {
            return this.$q.when(undefined);
        }
        return this.closeConversation(this._conversationsMap[contact_user_id]);
    },

    closeConversation: function(conversation) {
        var user_id = conversation.getContactUserId();
        conversation.closing = true;
        this._setLastOpenedConversation(user_id, true);
        return this.getChatClient().unsubscribeChat(user_id).then(function() {
            var idx = this.conversations.indexOf(conversation);
            if (this._conversationsMap) {
                delete this._conversationsMap[user_id];
            }
            if (idx < 0) {
                return undefined;
            }
            this.conversations.splice(idx, 1);
            if (this.currentConversation && user_id != this.currentConversation.getContactUserId()) {
                return this.currentConversation;
            }
            if (idx < this.conversations.length && this.conversations[idx]) {
                return this.conversations[idx];
            } else if (idx > 0 && this.conversations[idx - 1]) {
                return this.conversations[idx - 1];
            } else {
                return this.conversations[0];
            }
        }.bind(this)).then(function(conversation) {
            if (true !== conversation) {
                this.setCurrentConversation(conversation);
            }
            return conversation;
        }.bind(this)).finally(function() {
            delete conversation.closing;
        }.bind(this));
    },

    messageFactory: function() {
        return bbw.model.ConversationMessage;
    },

    getPhotoAlbumForConversationMessage: function(conversationMessage) {
        if (!conversationMessage.hasPhotosLoaded()) {
            return null;
        }
        return this.getPhotoAlbumForPhotos(conversationMessage.photos);
    },

    getPhotoAlbumForPhotos: function(photos) {
        var albumModel = this._modelFactory.create(bbw.model.PhotoAlbum);
        albumModel.replace(photos);
        return albumModel;
    },

    getPrivatePhotoAlbum: function(reloadExpiredAt) {
        if (!this._privatePhotoAlbum) {
            this._privatePhotoAlbum = this._modelFactory.create(bbw.model.PhotoAlbum);
            this._privatePhotoAlbum.prepare({
                album_type: 'private',
                size: bbw.service.ChatSvc.PHOTO_SIZE_NAME,
                extra_size: bbw.service.ChatSvc.PHOTO_SIZE_NAME_SMALL
            });
        }
        return this._privatePhotoAlbum.ensureIsLoaded(reloadExpiredAt).then(function() {
            return this._privatePhotoAlbum;
        }.bind(this));
    },

    getPrivatePhotosCollection: function(contact_user_id, photo_ids) {
        var photoPrivateCollectionModel = this._modelFactory.create(bbw.model.PhotoPrivateCollection);
        return photoPrivateCollectionModel.load(contact_user_id, photo_ids, bbw.service.ChatSvc.PHOTO_SIZE_NAME).then(function() {
            return photoPrivateCollectionModel;
        });
    },

    sendTextMessage: function(conversation, text, photo_ids) {
        var conversationMessage = this.messageFactory().createText(
            conversation.getContactUserId(),
            text,
            photo_ids
        );

        return this.sendMessage(conversation, conversationMessage);
    },

    sendWink: function(to_user_id) {
        var conversationMessage = this.messageFactory().createWink(to_user_id);

        return this.getChatClient().sendChatMessage(conversationMessage);
    },

    sendMessage: function(conversation, conversationMessage) {
        return this.getChatClient().sendChatMessage(conversationMessage).then(function(response) {
            if (response.args && response.args.serial && response.args.timestamp) {
                conversationMessage.setSent(
                    response.args.serial,
                    response.args.timestamp
                );
                conversation.addMessage(conversationMessage);
            } else {
                console.error(response);
                this._growl.error(response.args.error);
            }
        }.bind(this)).catch(function(error) {
            console.error(error);
            this._growl.error(error);
        }.bind(this));
    },

    _onMessage: function(inMessage) {
        var method = '_onMessage_' + inMessage.method;
        if (angular.isFunction(this[method])) {
            this[method](inMessage);
        }
    },

    _onMessage_chat_message: function(inMessage) {
        if (!this._conversationsMap) {
            return;
        }
        var contact_user_id;
        if (inMessage.args.from_user_id == this.getChatClient().getUserId()) {
            contact_user_id = inMessage.args.to_user_id;
        } else {
            contact_user_id = inMessage.args.from_user_id;
        }
        var conversation = this._conversationsMap[contact_user_id];
        if (conversation) {
            var serial = inMessage.args.serial;
            if (!serial) {
                throw new Error('Missing serial in message: ' + JSON.stringify(inMessage));
            }
            switch (inMessage.args.message_type) {
                case 'error':
                    conversation.markSendError(serial, inMessage.args.message_text);
                    break;
                case 'n_read':
                    conversation.markRead(serial) && this.getContactsModel().touch();
                    break;
                default:
                    this.getContactsModel().updateContactLastSerial(contact_user_id, serial);
                    var newMessage = conversation.addMessage(this.messageFactory().createFromArgs(
                        this.getChatClient().getUserId(), inMessage.args
                    ));
                    var newInverseRelation = newMessage.getInverseContactRelationChange();
                    if (newInverseRelation) {
                        conversation.getContact().relation_inverse = newInverseRelation;
                    }
                    if (this._chatIsActive && conversation === this.currentConversation && newMessage.isIncoming()) {
                        newMessage.setRead();
                        this.sendRead(conversation, serial);
                    }
                    this._onMessageReceivedCb && this._onMessageReceivedCb(newMessage);
                    break;
            }
            this._applyScope();
        }
    },

    _onMessage_total_unread: function(inMessage) {
        var count = inMessage.args.count;
        this.$rootScope.$broadcast(this.UNREAD_COUNT_EVENT_NAME, {
            count: count
        });
        this.getContactsModel().updateUnreadMessagesCount(count);
    },

    _onMessage_update_contacts: function(inMessage) {
        this._setUpdateContactsTimer();
        this.getContactsModel().setContactsFromResponse(inMessage.args);
    },

    _onCurrentConversationChanged: function() {
        this._markCurrentConversationRead();
        if (this._onCurrentConversationChangeCb) {
            this._onCurrentConversationChangeCb(this._chatIsActive ? this.currentConversation : undefined);
        }
    },

    _markCurrentConversationRead: function() {
        if (this.currentConversation && this._chatIsActive) {
            var lastIncomingSerial = this.currentConversation.getLastIncomingSerial();
            if (lastIncomingSerial) {
                this.sendRead(this.currentConversation, lastIncomingSerial);
            }
        }
    },

    _onConversationLoaded: function(conversation) {
        if (this.currentConversation === conversation) {
            this._markCurrentConversationRead();
            if (this._onCurrentConversationLoadedCb) {
                this._onCurrentConversationLoadedCb();
            }
        }
    },

    _applyScope: function() {
        this.$rootScope.$safeApply();
    },

    sendRead: function(conversation, lastSerial) {
        this.getContactsModel().touch();
        this.getChatClient().markRead(conversation.getContactUserId(), lastSerial);
    },

    onMessageTotalUnreadCountUpdate: function(fn) {
        this.$rootScope.$on(this.UNREAD_COUNT_EVENT_NAME, fn);
    },

    /**
     * @returns {bbw.model.Contacts}
     */
    getContactsModel: function() {
        if (!this._contactsModel) {
            this._contactsModel = this._modelFactory.create(bbw.model.Contacts);
        }
        return this._contactsModel;
    },

    getContactByUserId: function(user_id) {
        return this.findContactByUserId(user_id);
    },

    findContactByUserId: function(user_id) {
        return this.getContactsModel().findContactById(user_id);
    },

    createTemporaryContactByUserId: function(user_id) {
        return this.getContactsModel().createTemporaryContactById(user_id);
    },

    /**
     * @returns {bbw.service.chat.Client}
     */
    getChatClient: function() {
        if (!this._chatClient) {
            this._chatClient = this._chatClientFactory.create();
            this._chatClient.onMessageReceived(this._onMessage.bind(this));
            this._chatClient.onConnected(this._onConnected.bind(this));
        }
        return this._chatClient;
    },

    _initContacts: function() {
        return this.getContactsModel().initContactsFromApi();
    },

    setContactsFromResponse: function(contacts) {
        return this.getContactsModel().setContactsFromResponse(contacts);
    },

    _getLocalStorageLastOpenedConversationsKey: function() {
        return 'conversationLast_' + this.getChatClient().getUserId();
    }

});
